export const LOGIN_ROUTE = "/auth/login";

export const CALLBACK_QUERY = {
  AUTH: "auth",
  AUTH_ERROR: "auth_error",
  OK: "ok",
} as const;

export const CallbackOutcomeKind = {
  OK: "ok",
  ERROR: "error",
  INVALID: "invalid",
} as const;

export const CallbackFailure = {
  EXCHANGE_FAILED: "exchange_failed",
  SESSION_UNAVAILABLE: "session_unavailable",
  USER_UNAVAILABLE: "user_unavailable",
  UNKNOWN: "unknown",
} as const;

export type CallbackFailureValue = typeof CallbackFailure[keyof typeof CallbackFailure];

export const AUTH_FRONT_FAILURES: readonly CallbackFailureValue[] = [
  CallbackFailure.EXCHANGE_FAILED,
];

export const SessionPhase = {
  STARTING: "starting",
  AWAITING_USER: "awaiting_user",
  FAILED: "failed",
} as const;

export type SessionPhaseValue = typeof SessionPhase[keyof typeof SessionPhase];

export const CALLBACK_FAILURE_TITLE = "Não foi possível concluir o acesso";

export const BACK_TO_LOGIN_LABEL = "Voltar para o login";

export const CALLBACK_FAILURE_MESSAGE: Record<CallbackFailureValue, string> = {
  [CallbackFailure.EXCHANGE_FAILED]:
    "Houve uma falha ao finalizar o acesso. Tente entrar novamente.",
  [CallbackFailure.SESSION_UNAVAILABLE]:
    "Não conseguimos iniciar sua sessão. Tente entrar novamente.",
  [CallbackFailure.USER_UNAVAILABLE]:
    "Não conseguimos carregar os dados da sua conta. Tente entrar novamente em instantes.",
  [CallbackFailure.UNKNOWN]:
    "O acesso foi interrompido antes de terminar. Tente entrar novamente.",
};
